'use client';
import { Schedules } from '@/components/pages/contacts/ContactsPage/Schedules/Schedules';
import { useState } from 'react';
import { SchedulesData } from '@/components/pages/contacts/ContactsPage/Schedules/Schedules.types';

export const SchedulesColumn = () => {
  const [schedules, setSchedules] = useState<SchedulesData>();

  return (
    <Schedules schedules={schedules} setSchedules={setSchedules} />
  );
};